import React from "react";
import EditIcon from "../../Common/Svgs/EditIcon";
import QRCodeIcon from "../../Common/Svgs/QRCodeIcon";
import TrashIcon from "../../Common/Svgs/TrashIcon";
import AddToServiceIcon from "../../Common/Svgs/AddToServiceIcon";
import AddSquareIcon from "../../Common/Svgs/AddSquareIcon";
import MoreSquareIcon from "../../Common/Svgs/MoreSquareIcon";
import usePermission from "../../Core/hooks/usePermission";
import { PERMISSIONS, TENANT_RULE_VALUE } from "../Login/constants";
import RetireIcon from "../../Common/Svgs/RetireIcon";
import UnRetireIcon from "../../Common/Svgs/UnRetireIcon";
import useRule from "../../Core/hooks/useRule";

const useAssetThreeDotsOptions = () => {
  const hasKnownIssueAccess = useRule([TENANT_RULE_VALUE.KNOWN_ISSUES]);

  const threeDotsOptions = [
    {
      id: 1,
      value: "Edit Details",
      icon: <EditIcon className="text-dark-gray group-hover:text-black" />,
      hasPermission: usePermission([PERMISSIONS.POWER_AFRICA_ASSET_EDIT]),
    },
    {
      id: 2,
      value: "Add Issues",
      icon: <AddSquareIcon className="text-dark-gray group-hover:text-black" />,
      hasPermission: usePermission([PERMISSIONS.POWER_AFRICA_ASSET_ISSUE_ADD]),
    },
    {
      id: 3,
      value: "View Issues",
      icon: (
        <MoreSquareIcon className="text-dark-gray group-hover:text-black" />
      ),
      hasPermission: usePermission([PERMISSIONS.POWER_AFRICA_ASSET_ISSUE_VIEW]),
    },
    {
      id: 4,
      value: "Add to Service",
      icon: (
        <AddToServiceIcon className="text-dark-gray group-hover:text-black" />
      ),
      hasPermission: usePermission([
        PERMISSIONS.POWER_AFRICA_ASSET_ADD_TO_SERVICE,
      ]),
    },
    {
      id: 5,
      value: "Check Service",
      icon: (
        <AddToServiceIcon className="text-dark-gray group-hover:text-black" />
      ),
      hasPermission: usePermission([
        PERMISSIONS.SERVICE_VIEW,
        PERMISSIONS.SERVICE_VIEW_AND_EDIT,
      ]),
    },
    {
      id: 6,
      value: "View QR Code",
      icon: <QRCodeIcon className="text-dark-gray group-hover:text-black" />,
      hasPermission: usePermission([PERMISSIONS.POWER_AFRICA_ASSET_VIEW_QR]),
    },
    {
      id: 8,
      value: "Retire",
      icon: <RetireIcon className="text-dark-gray group-hover:text-black" />,
      hasPermission: usePermission([PERMISSIONS.POWER_AFRICA_ASSET_DELETE]),
    },
    {
      id: 9,
      value: "Un-Retire",
      icon: <UnRetireIcon className="text-dark-gray group-hover:text-black" />,
      hasPermission: usePermission([PERMISSIONS.POWER_AFRICA_ASSET_DELETE]),
    },
    {
      id: 7,
      value: "Delete Asset",
      icon: <TrashIcon className="text-alert-red" />,
      hasPermission: usePermission([PERMISSIONS.POWER_AFRICA_ASSET_DELETE]),
    },
  ];

  return hasKnownIssueAccess
    ? threeDotsOptions
    : threeDotsOptions.filter((t) => t.id !== 2 && t.id !== 3);
};

export default useAssetThreeDotsOptions;
